import type { FaireProductEntity } from "../../entity_types/product";

export const p_hk54r8prcy: FaireProductEntity = {
  token: "p_hk54r8prcy",
  type: "product",
  name: "Building blocks - Rainbow",
  brandToken: "b_59a092qk0m",
  brandName: "Goki America",
  imageUrl:
    "https://cdn.faire.com/fastly/41505a4cafc8247a66b06dc4f8d48e48c14eb026d9ef85ac5edde9d66da59d1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36cfe582a351027e7660ce8908d86e244482ad5ea7c6a35dd00e24b89a43b16d.jpeg",
    "https://cdn.faire.com/fastly/f1face9ff01741644314f17e692e22a1e92bc90b0ee9fccb44d9e5f56d771708.jpeg",
    "https://cdn.faire.com/fastly/9d725a999f77a0480fd8c7e3a06bd85da65b54982bcc02b91f20932669eab902.jpeg",
    "https://cdn.faire.com/fastly/c59d121fe71d200cb046834fe887dece3dbfb9998b6f7658a9dd7f25a85ef2a1.jpeg",
    "https://cdn.faire.com/fastly/db445fbd2269cd134ffc91f3313466622c51d845c1d8880e4c25f79f4da69c18.jpeg",
    "https://cdn.faire.com/fastly/ddd7cf80d32f358faac44ef46966830efd52e1a13fa7c05c846750752017eb9c.jpeg",
    "https://cdn.faire.com/fastly/f1aa0215fea6b240e46ebb3674d7d7e141dcff7baa67fcfccd6e5de3a9f91808.jpeg",
    "https://cdn.faire.com/fastly/93d94996b5ca083a5f2615ec5c11c627820a4b8099729492502af48133d8d92c.jpeg",
    "https://cdn.faire.com/fastly/2309e43fc922c2922b39f1f9aab0670a556632084f6554fb3a9d06bc3e1aee05.jpeg",
    "https://cdn.faire.com/fastly/e22e71f908a82382c857589f0cbff4fe2166196ddb9756544689c64e40d90ce6.jpeg",
    "https://cdn.faire.com/fastly/18c54e1272f5b77dec4d8ffb75078dd9b5d80be579542b77129bd62b20407622.jpeg",
    "https://cdn.faire.com/fastly/a71bc8c504aeeb7f66b0df57e7f24ccaea84ee9df77d877891d746bee3b4cd69.jpeg",
    "https://cdn.faire.com/fastly/26c20fb52534edefee6eaa944d02f01b2e47bce4cb3f7070aeadb2f748ef239d.png",
  ],
  priceDollars: 49.95,
  description:
    "This cheerful rainbow made of maple wood lets children stack and sort while playfully learning sizes, sequences and colors. There are no limits to building magical worlds in open play. Simply a classic among wooden toys.\n\nThe hand-painted colors in this rainbow are harmoniously coordinated, highlighting the natural wood rather than covering it up. High-quality maple wood and European craftsmanship enhance this wooden toy.\n\nThis rainbow seamlessly integrates into both Montessori and Waldorf educational philosophies, nurturing independent learning and the joy of discovery, in line with the principles of Maria Montessori and Waldorf education.\n\nThe Rainbow's versatility encourages endless creativity: younger children will enjoy stacking, sorting, and building with it. As they grow older, they will repurpose it in imaginative ways, such as  a fence for animals, a tunnel or bridge for vehicles, a house for small figures, or for constructing intricate sculptures. This set includes 11 pieces",
  tags: [],
  msrpDollars: 99.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:56.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
